var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerBody = void 0;
var DrawerBody_1 = __importDefault(require("./DrawerBody"));
exports.DrawerBody = DrawerBody_1.default;
exports.default = DrawerBody_1.default;
//# sourceMappingURL=index.js.map